import React from 'react';

export const ModelTitle: React.FC<{
    left: string;
    right?: string;
    onRightClick?: Function;
}> = React.memo(({ left, right, onRightClick }) => {
    return (
        <div className="c-ai-content__title">
            <div className="c-ai-content__title-left">{left}</div>
            {right ? (
                <div
                    className="c-ai-content__title-right"
                    onClick={() => {
                        onRightClick?.();
                    }}
                >
                    {right}
                </div>
            ) : null}
        </div>
    );
});
